// Mock API functions for frontend development

export const submitContactForm = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Contact form submitted (MOCK):', formData);
  
  return {
    success: true,
    message: 'Thank you for your inquiry. Our team will contact you within 24 hours.'
  };
};

export const subscribeNewsletter = async (email) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 800));
  
  console.log('Newsletter subscription (MOCK):', email);
  
  return {
    success: true,
    message: 'Successfully subscribed to our intelligence briefings.'
  };
};

export const getInsights = () => {
  return [
    {
      id: 1,
      title: 'Global LNG Markets: Supply Dynamics Reshape Trade Flows',
      category: 'Natural Gas',
      date: '2024-12-18',
      excerpt: 'New liquefaction capacity in North America and Qatar is fundamentally altering global LNG trade patterns, with implications for pricing mechanisms across Asian and European markets.',
      readTime: '8 min read'
    },
    {
      id: 2,
      title: 'Critical Minerals Supply Chain: Geopolitical Risk Assessment',
      category: 'Mining',
      date: '2024-12-15',
      excerpt: 'Our analysis of lithium, cobalt, and rare earth supply chains reveals concentration risks that could impact energy transition timelines and costs through 2030.',
      readTime: '12 min read'
    },
    {
      id: 3,
      title: 'Renewable Energy Investment Trends: Q4 2024 Analysis',
      category: 'Renewables',
      date: '2024-12-12',
      excerpt: 'Capital flows into solar and wind projects accelerated in Q4, with emerging markets capturing an increasing share of global renewable energy investment.',
      readTime: '10 min read'
    }
  ];
};

export const getCommodities = () => {
  return [
    {
      name: 'Crude Oil',
      description: 'Comprehensive analysis of global crude oil markets, production forecasts, and price outlooks',
      coverage: ['WTI', 'Brent', 'Dubai', 'Regional Differentials']
    },
    {
      name: 'Natural Gas',
      description: 'Intelligence on natural gas and LNG markets, infrastructure, and cross-regional trade flows',
      coverage: ['Henry Hub', 'TTF', 'JKM', 'LNG Trade']
    },
    {
      name: 'Coal',
      description: 'Thermal and metallurgical coal market analysis, supply-demand dynamics, and transition impacts',
      coverage: ['Thermal Coal', 'Metallurgical Coal', 'Trade Flows']
    },
    {
      name: 'Power & Renewables',
      description: 'Electricity markets, renewable energy trends, and energy transition intelligence',
      coverage: ['Solar', 'Wind', 'Hydro', 'Power Pricing']
    },
    {
      name: 'Critical Minerals',
      description: 'Strategic analysis of minerals essential for energy transition and technology sectors',
      coverage: ['Lithium', 'Cobalt', 'Rare Earths', 'Copper']
    },
    {
      name: 'Metals & Mining',
      description: 'Industrial metals markets, mining operations, and mineral supply chain analysis',
      coverage: ['Iron Ore', 'Aluminum', 'Zinc', 'Nickel']
    }
  ];
};

export const getCountryCoverage = () => {
  return [
    {
      region: 'North America',
      countries: ['United States', 'Canada', 'Mexico'],
      focus: 'Shale production, LNG exports, USMCA trade dynamics'
    },
    {
      region: 'Europe',
      countries: ['United Kingdom', 'Germany', 'Norway', 'Netherlands', 'Poland'],
      focus: 'Energy security, gas markets, renewable transition'
    },
    {
      region: 'Middle East',
      countries: ['Saudi Arabia', 'UAE', 'Qatar', 'Iraq', 'Kuwait'],
      focus: 'OPEC+ policy, oil production, petrochemicals'
    },
    {
      region: 'Asia Pacific',
      countries: ['China', 'India', 'Japan', 'South Korea', 'Australia'],
      focus: 'Demand growth, LNG imports, critical minerals'
    },
    {
      region: 'Latin America',
      countries: ['Brazil', 'Argentina', 'Colombia', 'Chile', 'Peru'],
      focus: 'Pre-salt production, lithium, copper mining'
    },
    {
      region: 'Africa',
      countries: ['Nigeria', 'Angola', 'South Africa', 'Egypt', 'Algeria'],
      focus: 'Oil & gas development, mining, energy access'
    }
  ];
};
